import React from 'react';
import Card from '../ui/Card';
import GroupInviteLinkActions from './GroupInviteLinkActions';
import { typography } from '../../design-system/tokens';

export default function EmptyLeagueNudge({ groupId, groupName }) {
  if (!groupId) return null;

  return (
    <Card
      variant="admin"
      className="p-4 border-amber-500/30 bg-gradient-to-br from-amber-500/10 via-black/40 to-black/60"
    >
      <p className={`${typography.microWide} text-amber-300 mb-1`}>This league needs players</p>
      <p className="text-sm font-bold text-gray-200 leading-relaxed">
        Invite 1 friend to unlock standings competition.
      </p>
      <div className="mt-4">
        <GroupInviteLinkActions
          groupId={groupId}
          groupName={groupName}
          copyLabel="Copy Invite Link"
          shareLabel="Share League"
        />
      </div>
    </Card>
  );
}
